export default {
    job_opportunities: {
        name: '',
        fields: {
          title_th: 'ตำแหน่งงาน (ไทย)',
          title_en: 'ตำแหน่งงาน (อังกฤษ)',
          branch_th: 'สาขา (ไทย)',
          branch_en: 'สาขา (อังกฤษ)',
          experience_th: 'ประสบการณ์ (ไทย)',
          experience_en: 'ประสบการณ์ (อังกฤษ)',
          number: 'จำนวน',
          note: '',
          description_th: 'คำอธิบาย (ไทย)',
          description_en: 'คำอธิบาย (อังกฤษ)',
          period_th: 'ระยะเวลา (ไทย)',
          period_en: 'ระยะเวลา (อังกฤษ)',
          file: 'ชื่อไฟล์',
          title: 'ตำแหน่งงาน (ไทย/อังกฤษ)',
          description: 'คำอธิบาย (ไทย/อังกฤษ)',
          edit: {
            title: 'แก้ไข Job Opportunities',
            file: 'File',
            attachment_helper: 'อณุญาติเฉพาะไฟล์ PDF',
          },
          create: {
            title: 'สร้าง Job Opportunity',
          },
        }
    }
}